<div class="box">
    <div class="header">
        <div>
            <h2>Detalhes da Notificação</h2>
            <p>Visualize as informações completas da notificação</p>
        </div>

        <button class="close" type="button" (click)="fechar()" aria-label="Fechar">
            <i-lucide name="x" size="18"></i-lucide>
        </button>
    </div>

    <div class="top">
        <div class="icon" [ngClass]="notificacao.type">
            <i-lucide [name]="icone" size="18"></i-lucide>
        </div>

        <div class="topText">
            <div class="titulo">{{ notificacao.title }}</div>
            <div class="subtitulo">{{ notificacao.subtitle }}</div>

            <span class="tag" [ngClass]="notificacao.type">
                {{ notificacao.typeLabel }}
            </span>
        </div>
    </div>

    <div class="msg">
        {{ notificacao.message || notificacao.text }}

    </div>

    <div class="info-group">
        <div class="info-group-details">
            <i-lucide name="calendar" size="18"></i-lucide>
            <div class="infoText">
                <div class="label">Data:</div>
                <div class="value">{{ notificacao.date }}</div>
            </div>
        </div>

        <div class="info-group-details">
            <i-lucide name="tag" size="18"></i-lucide>
            <div class="infoText">
                <div class="label">Motivo:</div>
                <div class="value">{{ notificacao.reason || '-' }}</div>
            </div>
        </div>

        <div class="info-group-details">
            <i-lucide name="clock" size="18"></i-lucide>
            <div class="infoText">
                <div class="label">Horário:</div>
                <div class="value">{{ notificacao.time }}</div>
            </div>
        </div>
    </div>

    <div class="divider"></div>

    <div class="actions">
        <button class="btn btn-sm btn-primary" type="button" (click)="acessarModulo()"
            [disabled]="!notificacao.moduleUrl">
            <i-lucide name="external-link" size="18"></i-lucide>
            Acessar módulo
        </button>

        <button class="btn btn-sm btn-outline" type="button" (click)="copiarLink()"
            [disabled]="!(notificacao.shareUrl || notificacao.moduleUrl)">
            Compartilhar Link
        </button>
    </div>
</div>